/* assets/wubs-cart-weight-upsell.js */
/* v2.0.2 - add-only + debugger overlay (?debugger) + deep DOM (shadow safe) + fetch hook + drawer observer (debug) */

(function () {
  if (window.__wubsCartWeightUpsellV202) return;
  window.__wubsCartWeightUpsellV202 = true;

  var DEBUG = /(?:\?|&)debugger(?:=1)?(?:&|$)/i.test(window.location.search || "");
  var THRESHOLD_G = 80000;

  // ----------------------------
  // Deep query (includes shadow roots)
  // ----------------------------
  function uniq(arr) {
    var out = [];
    var seen = new Set();
    for (var i = 0; i < arr.length; i++) {
      var el = arr[i];
      if (!el || seen.has(el)) continue;
      seen.add(el);
      out.push(el);
    }
    return out;
  }

  function collectRoots(root, roots) {
    if (!root) return;
    roots.push(root);

    var walker = document.createTreeWalker(
      root instanceof Document ? root.documentElement : root,
      NodeFilter.SHOW_ELEMENT,
      null
    );

    while (walker.nextNode()) {
      var node = walker.currentNode;
      if (node && node.shadowRoot) collectRoots(node.shadowRoot, roots);
    }
  }

  function qsaDeep(sel) {
    var roots = [];
    collectRoots(document, roots);

    var found = [];
    for (var i = 0; i < roots.length; i++) {
      try { found = found.concat([].slice.call(roots[i].querySelectorAll(sel))); } catch (e) {}
    }
    return uniq(found);
  }

  function findWraps() {
    var a = qsaDeep("[data-wubs-cart-weight-upsell]");
    var b = qsaDeep("[data-wubs-excl-upsell]");
    var c = qsaDeep(".wubs-excl-upsell");
    return uniq(a.concat(b).concat(c));
  }

  // ----------------------------
  // Debug overlay (always visible when ?debugger)
  // ----------------------------
  var dbgEl = null;

  function ensureDebugger() {
    if (!DEBUG) return null;
    if (dbgEl && document.body.contains(dbgEl)) return dbgEl;

    dbgEl = document.createElement("div");
    dbgEl.id = "wubs-upsell-debugger";
    dbgEl.style.position = "fixed";
    dbgEl.style.right = "12px";
    dbgEl.style.bottom = "12px";
    dbgEl.style.zIndex = "999999";
    dbgEl.style.width = "380px";
    dbgEl.style.maxWidth = "calc(100vw - 24px)";
    dbgEl.style.maxHeight = "48vh";
    dbgEl.style.overflow = "auto";
    dbgEl.style.background = "rgba(255,255,255,0.96)";
    dbgEl.style.border = "1px solid rgba(0,0,0,0.25)";
    dbgEl.style.padding = "10px";
    dbgEl.style.fontSize = "12px";
    dbgEl.style.lineHeight = "1.35";
    dbgEl.style.whiteSpace = "pre-wrap";
    dbgEl.style.wordBreak = "break-word";
    dbgEl.style.boxShadow = "0 8px 30px rgba(0,0,0,0.18)";

    var head = document.createElement("div");
    head.style.display = "flex";
    head.style.alignItems = "center";
    head.style.justifyContent = "space-between";
    head.style.gap = "8px";
    head.style.marginBottom = "8px";

    var title = document.createElement("div");
    title.textContent = "Upsell debugger (?debugger)";
    title.style.fontWeight = "600";

    var btn = document.createElement("button");
    btn.type = "button";
    btn.textContent = "X";
    btn.style.border = "1px solid rgba(0,0,0,0.25)";
    btn.style.background = "transparent";
    btn.style.padding = "2px 8px";
    btn.style.cursor = "pointer";
    btn.onclick = function () { dbgEl.remove(); };

    head.appendChild(title);
    head.appendChild(btn);

    var body = document.createElement("div");
    body.setAttribute("data-body", "");

    dbgEl.appendChild(head);
    dbgEl.appendChild(body);

    document.body.appendChild(dbgEl);
    return dbgEl;
  }

  function setDebugText(txt) {
    if (!DEBUG) return;
    ensureDebugger();
    var body = dbgEl && dbgEl.querySelector("[data-body]");
    if (body) body.textContent = txt || "";
  }

  // ----------------------------
  // Cart fetch (no-store)
  // ----------------------------
  var _cartInFlight = null;

  function getCartFresh() {
    if (_cartInFlight) return _cartInFlight;

    _cartInFlight = fetch("/cart.js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
      cache: "no-store"
    })
      .then(function (res) {
        if (!res.ok) throw new Error("cart.js failed");
        return res.json();
      })
      .catch(function () { return null; })
      .finally(function () { _cartInFlight = null; });

    return _cartInFlight;
  }

  function cartHasVariant(cart, variantId) {
    if (!cart || !cart.items || !variantId) return false;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var id1 = it && it.id ? Number(it.id) : 0;         // /cart.js: variant id
      var id2 = it && it.variant_id ? Number(it.variant_id) : 0;
      if (id1 === variantId || id2 === variantId) return true;
    }
    return false;
  }

  function cartWeightG(cart) {
    return cart && cart.total_weight ? Number(cart.total_weight) : 0;
  }

  // ----------------------------
  // Apply sections (after add)
  // ----------------------------
  function applySections(sections) {
    if (!sections) return;

    if (sections["cart-drawer"]) {
      var doc = new DOMParser().parseFromString(sections["cart-drawer"], "text/html");
      var newInner = doc.querySelector("#CartDrawer");
      var curInner = document.querySelector("#CartDrawer");
      if (newInner && curInner) curInner.innerHTML = newInner.innerHTML;
    }

    if (sections["cart-icon-bubble"]) {
      var doc2 = new DOMParser().parseFromString(sections["cart-icon-bubble"], "text/html");
      var newBubble = doc2.querySelector("#cart-icon-bubble");
      var curBubble = document.querySelector("#cart-icon-bubble");
      if (newBubble && curBubble) curBubble.replaceWith(newBubble);
    }

    if (typeof window.wubsRedrawCartTotals === "function") window.wubsRedrawCartTotals();

    var drawerEl = document.querySelector("cart-drawer");
    if (drawerEl && typeof drawerEl.open === "function") drawerEl.open();
  }

  function showNote(wrap, msg) {
    var n = wrap && wrap.querySelector("[data-note]");
    if (!n) return;
    n.textContent = msg || "";
    n.hidden = !msg;
  }

  // ----------------------------
  // Debug refresh (no show/hide)
  // ----------------------------
  async function debugRefresh(reason) {
    if (!DEBUG) return;

    var wrapsNew = qsaDeep("[data-wubs-cart-weight-upsell]").length;
    var wrapsLegacy = qsaDeep("[data-wubs-excl-upsell]").length;
    var wrapsClass = qsaDeep(".wubs-excl-upsell").length;

    var wraps = findWraps();
    var cart = await getCartFresh();

    var lines = [];
    lines.push("reason: " + (reason || "debugRefresh"));
    lines.push("time: " + new Date().toLocaleTimeString());
    lines.push("url: " + (window.location.pathname + window.location.search));
    lines.push("threshold_g: " + THRESHOLD_G);
    lines.push("");
    lines.push("wraps (new attr): " + wrapsNew);
    lines.push("wraps (legacy attr): " + wrapsLegacy);
    lines.push("wraps (class): " + wrapsClass);
    lines.push("wraps (effective): " + wraps.length);
    lines.push("");

    if (!cart || !cart.items) {
      lines.push("cart: null (cart.js fail?)");
      setDebugText(lines.join("\n"));
      return;
    }

    var wG = cartWeightG(cart);
    lines.push("cart_items: " + cart.items.length);
    lines.push("cart_weight_g: " + wG);
    lines.push("cart_weight_ok: " + (wG >= THRESHOLD_G));
    lines.push("");

    if (!wraps.length) {
      lines.push("NOTE: Ingen upsell markup i DOM.");
      lines.push("Om du tycker den borde synas nu:");
      lines.push("- kontrollera att snippet renderas i rätt section som faktiskt uppdateras i drawer");
      lines.push("- kontrollera att cart.total_weight faktiskt blir >= 80000 (produktvikter i Shopify)");
      setDebugText(lines.join("\n"));
      return;
    }

    wraps.forEach(function (wrap, idx) {
      var handle = (wrap.getAttribute("data-handle") || "").trim();
      var vid = parseInt(wrap.getAttribute("data-variant-id") || "0", 10);
      var inCart = cartHasVariant(cart, vid);

      lines.push("[" + (idx + 1) + "]");
      lines.push(" handle: " + (handle || "(empty)"));
      lines.push(" variant_id: " + (vid || 0));
      lines.push(" variant_in_cart: " + inCart);
      lines.push(" would_liquid_show: " + ((wG >= THRESHOLD_G) && !inCart && cart.items.length > 0));
      lines.push(" dom_hidden_attr: " + (wrap.hidden ? "true" : "false"));
      lines.push("");
    });

    setDebugText(lines.join("\n"));
  }

  var raf = null;
  function scheduleDebug(reason) {
    if (!DEBUG) return;
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      raf = null;
      debugRefresh(reason || "scheduleDebug");
    });
  }

  // ----------------------------
  // Hook fetch: log cart mutations (debug)
  // ----------------------------
  function hookFetch() {
    if (window.__wubsUpsellFetchHookedV202) return;
    window.__wubsUpsellFetchHookedV202 = true;

    var origFetch = window.fetch;
    if (typeof origFetch !== "function") return;

    window.fetch = function () {
      var args = arguments;
      var url = "";
      try {
        url = (typeof args[0] === "string") ? args[0] : (args[0] && args[0].url) ? args[0].url : "";
      } catch (e) {}

      var isCartEndpoint = /\/cart\/(add|change|update|clear)\.js(\?|$)/i.test(url);

      var p = origFetch.apply(this, args);

      if (isCartEndpoint) {
        return p.then(function (res) {
          // efter cart-change: låt temat rendera klart, sen debugga
          setTimeout(function () { scheduleDebug("fetch " + url); }, 150);
          setTimeout(function () { scheduleDebug("fetch " + url + " (late)"); }, 700);
          return res;
        });
      }

      return p;
    };
  }

  // ----------------------------
  // Observe CartDrawer mutations (debug)
  // ----------------------------
  var drawerObs = null;

  function attachDrawerObserver() {
    if (!DEBUG) return;
    try {
      var drawer = document.querySelector("#CartDrawer");
      if (!drawer) return;

      if (drawerObs && drawerObs.__target === drawer) return;

      if (drawerObs) {
        try { drawerObs.disconnect(); } catch (e) {}
        drawerObs = null;
      }

      drawerObs = new MutationObserver(function () {
        scheduleDebug("CartDrawer mutation");
      });
      drawerObs.__target = drawer;
      drawerObs.observe(drawer, { childList: true, subtree: true });
    } catch (e) {}
  }

  function observeBodyForDrawer() {
    if (!DEBUG) return;
    if (document.body.__wubsUpsellBodyObsV202) return;
    try {
      var obs = new MutationObserver(function () {
        attachDrawerObserver();
      });
      obs.observe(document.body, { childList: true, subtree: true });
      document.body.__wubsUpsellBodyObsV202 = obs;
    } catch (e) {}
  }

  // ----------------------------
  // Add handler (only behavior we keep)
  // ----------------------------
  document.addEventListener("click", async function (e) {
    var btn = e.target.closest("[data-wubs-cart-weight-upsell] [data-add], [data-wubs-excl-upsell] [data-add], .wubs-excl-upsell [data-add]");
    if (!btn) return;

    var wrap =
      btn.closest("[data-wubs-cart-weight-upsell]") ||
      btn.closest("[data-wubs-excl-upsell]") ||
      btn.closest(".wubs-excl-upsell");

    if (!wrap) return;

    var variantId = parseInt(wrap.getAttribute("data-variant-id") || "0", 10);
    if (!variantId) {
      showNote(wrap, "Saknar variant_id.");
      return;
    }

    showNote(wrap, "");
    btn.setAttribute("aria-busy", "true");

    try {
      var payload = {
        items: [{ id: variantId, quantity: 1 }],
        sections: ["cart-drawer", "cart-icon-bubble"],
        sections_url: window.location.pathname + window.location.search
      };

      var addRes = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify(payload)
      });

      if (!addRes.ok) {
        var errTxt = "";
        try { errTxt = await addRes.text(); } catch (_) {}
        throw new Error("cart/add failed: " + addRes.status + " " + errTxt);
      }

      var data = await addRes.json();
      if (data && data.sections) applySections(data.sections);
      else window.dispatchEvent(new CustomEvent("cart:refresh"));

      // debug after add
      scheduleDebug("after_add");
    } catch (err) {
      console.error("[wubs-cart-weight-upsell] add error", err);
      showNote(wrap, "Kunde inte uppdatera varukorgen direkt. Kolla console.");
      scheduleDebug("after_add error");
    } finally {
      btn.removeAttribute("aria-busy");
    }
  });

  // ----------------------------
  // Boot
  // ----------------------------
  function boot() {
    if (DEBUG) ensureDebugger();
    hookFetch();
    attachDrawerObserver();
    observeBodyForDrawer();
    scheduleDebug("boot");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  window.wubsCartWeightUpsellDebug = function () {
    scheduleDebug("manual");
  };
})();
